var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Frame from 'react-frame-component';

import "./PreviewIframe.scss";

var PreviewIframe = (_temp2 = _class = function (_Component) {
    _inherits(PreviewIframe, _Component);

    function PreviewIframe() {
        var _temp, _this, _ret;

        _classCallCheck(this, PreviewIframe);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidUpdate = function (prevProps) {
            if (_this.props.children !== prevProps.children) {}
        }, _this.state = {}, _this.iframeDidMount = function () {
            _this.getHead();
        }, _this.getHead = function () {
            var stylesheets = [],
                styles = [];

            var linkTags = document.head.querySelectorAll('[rel="stylesheet"]');
            var styleTags = document.head.getElementsByTagName("style");

            for (var i = 0; i < linkTags.length; i++) {
                var styleheet = linkTags[i].getAttribute('href');
                stylesheets.push(styleheet);
            }

            for (var _i = 0; _i < styleTags.length; _i++) {
                var style = styleTags[_i].innerHTML;
                styles.push(style);
            }

            var head = [];

            stylesheets.forEach(function (stylesheet) {
                head.push(React.createElement('link', { type: 'text/css', rel: 'stylesheet', href: stylesheet }));
            });

            styles.forEach(function (style) {
                head.push(React.createElement(
                    'style',
                    null,
                    style
                ));
            });

            _this.setState({
                head: head
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PreviewIframe.prototype.componentDidMount = function componentDidMount() {
        this.getHead();
    };

    PreviewIframe.prototype.render = function render() {
        var head = this.state.head;


        if (!head) {
            return false;
        }

        var template = '<!DOCTYPE html><html><head></head><body id="preview-iframe"></body></html>';

        return React.createElement(
            'div',
            { className: 'admin-preview  preview--iframe' },
            React.createElement(
                Frame,
                { className: 'preview__iframe', initialContent: template, head: head, mountTarget: '#preview-iframe', contentDidMount: this.iframeDidMount },
                this.props.children
            )
        );
    };

    return PreviewIframe;
}(Component), _class.defaultProps = {}, _temp2);
PreviewIframe.propTypes = process.env.NODE_ENV !== "production" ? {
    children: PropTypes.node.isRequired
} : {};


export default PreviewIframe;